import { useEffect } from 'react';
export function useFavicon({
  faviconUrl
}) {
  useEffect(() => {
    if (!faviconUrl) {
      return;
    }

    // Remove all existing favicon elements to avoid conflicts
    document.querySelectorAll('link[rel*="icon"]').forEach(el => el.remove());
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = faviconUrl.endsWith('.ico') ? 'image/x-icon' : 'image/png';
    favicon.href = faviconUrl;
    document.head.appendChild(favicon);
  }, [faviconUrl]);
}